import _ from 'lodash';

import { filterTimeRangeResult, formatTimeRange, loopData } from '../report-data-util';

const countDataModal = {
  visitor_cnt: 0, // 访客数
  visit_cnt: 0, // 访问次数
  visit_page_cnt: 0, // 浏览量
  conv_cnt: 0, // 对话数
  conv_cnt_rate: '0.0%', // 对话率
  effective_conv_cnt: 0, // 有效对话数
  effective_conv_cnt_rate: '0.0%', // 有效对话率
  msg_cnt: 0, // 消息量
  avg_wait_time: 0, // 平均首次响应时长
  avg_conv_duration: 0, // 平均对话时长
  client_access_conv_cnt: 0,
  client_request_conv_cnt: 0,
  avg_resp_time: 0, // 遗漏对话数
  missed_conv_cnt: 0,
  good_conv_cnt: 0,
  medium_conv_cnt: 0,
  bad_conv_cnt: 0
};

const keyValue = [
  'visit_cnt', // 访问数
  'visitor_cnt',
  'visit_page_cnt', // 浏览量
  'conv_cnt', // 对话量
  'effective_conv_cnt', // 有效对话量
  'msg_cnt', // 消息量
  'wait_time', // 客服首次响应时间
  'conv_duration', // 对话时长
  'client_access_conv_cnt',
  'client_request_conv_cnt',
  'avg_resp_time',
  'missed_conv_cnt',
  'good_conv_cnt',
  'medium_conv_cnt',
  'bad_conv_cnt'
];

// 构建服务器返回数据
export const buildResponseDataToStore = (webResponse, timeRange) => {
  const response = filterTimeRangeResult(webResponse, formatTimeRange(timeRange));

  const detail = response.stats;

  const dataMode = {
    ...countDataModal,
    conv_duration: 0,
    wait_time: 0
  };

  // 无脑加数据
  loopData(detail, log => {
    if (log) {
      _.forEach(keyValue, key => {
        dataMode[key] += log[key] || 0;
      });
    }
  });

  // 计算值
  dataMode.avg_wait_time = Math.ceil(dataMode.wait_time / (dataMode.effective_conv_cnt || 1));
  dataMode.avg_response_time =
    Math.ceil(dataMode.avg_resp_time / (dataMode.effective_conv_cnt - dataMode.missed_conv_cnt)) || 0;
  dataMode.avg_conv_duration = Math.ceil(dataMode.conv_duration / (dataMode.effective_conv_cnt || 1));
  dataMode.client_conv_rate =
    dataMode.client_request_conv_cnt > 0 && dataMode.client_request_conv_cnt > 0
      ? `${((dataMode.client_access_conv_cnt / dataMode.client_request_conv_cnt) * 100).toFixed(2)}%`
      : '-';
  dataMode.conv_cnt_rate =
    dataMode.conv_cnt > 0 && dataMode.visit_cnt > 0
      ? `${((dataMode.conv_cnt * 100) / dataMode.visit_cnt).toFixed(2)}%`
      : '-';
  dataMode.effective_conv_cnt_rate =
    dataMode.visit_cnt > 0 && dataMode.conv_cnt > 0
      ? `${((dataMode.effective_conv_cnt * 100) / dataMode.conv_cnt).toFixed(2)}%`
      : '-';

  return dataMode;
};
